import { SelfHostedIconUrl } from "@p0security/shared/integrations/constants";
import { SelfHostedComponents } from "@p0security/shared/integrations/resources/self-hosted/components";
import { useCallback } from "react";

import { Install, InstallProps } from "../Install/Install";
import { selfHostedInstaller } from "./install/install";

export const SelfHosted = (
  props: Pick<
    InstallProps<typeof SelfHostedComponents>,
    "cardOverride" | "onInstall"
  >
) => {
  const itemKind = useCallback(() => "environment", []);
  const identifier = useCallback(() => "id", []);

  return (
    <Install<typeof SelfHostedComponents>
      components={SelfHostedComponents}
      installer={selfHostedInstaller}
      integration="self-hosted"
      itemKind={itemKind}
      identifier={identifier}
      logo={SelfHostedIconUrl}
      title={"Self-hosted"}
      {...props}
    />
  );
};
